import ConfirmDialog from "../../../components/customHelpers/ConfirmDialog";
import Controls from "../../../components/controls/Controls";
import Norecords from "../../../components/customHelpers/Norecords";
import Loading from "../../../components/customHelpers/Loading";
import Layout from "../../../components/layout/Layout";
import {
  TableBody,
  TableRow,
  TableCell,
  Typography,
  makeStyles,
} from "@material-ui/core";
import { Grid, Toolbar, InputAdornment } from "@material-ui/core";
import { useEffect, useState } from "react";
import { MdOutlineDelete } from "react-icons/md";
import { IoMdAdd } from "react-icons/io";
import { AiOutlineSearch } from "react-icons/ai";
import useTable from "../../../components/customHelpers/usePaginationTable";
import Notify from "../../../components/customHelpers/Notify";
import Notification from "../../../components/customHelpers/Notification";
import { MdAssignmentInd } from "react-icons/md";
import Admin from "../../../components/auth/Admin";
import Order from "../../../actions/order";
import UpdateOrder from "../../../components/forms/addOrders";
import Popup from "../../../components/customHelpers/Popup";
import produce from "immer";
import { FiEdit, FiEye } from "react-icons/fi";
import { useHistory } from "react-router-dom";
import Assigntff from "./assignToUser";
import { isAuth } from "../../../actions/auth";
import SearchIcon from "@mui/icons-material/Search";
import ClearAllIcon from "@mui/icons-material/ClearAll";
import Customer from "../../../actions/customer";
import {
  Box,
  Radio,
  FormControlLabel,
  FormGroup,
  Paper,
  Autocomplete,
  TextField,
  MenuItem,
  Button,
  Select,
  Pagination,
} from "@mui/material";
import OrderAssignConfirmDialog from "../../../components/customHelpers/OrderAssignDialog";
import { statues } from "../../../utils/utils";
const useStyles = makeStyles((theme) => ({
  image: {
    borderRadius: "55%",
    height: "45px",
    width: "45px",
  },
  paginationContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "end",
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
    borderTop: `1px solid ${theme.palette.divider}`,
  },
  pageSizeSelect: {
    minWidth: 120,
    marginRight: theme.spacing(2),
  },
}));
const headCells = [
  { id: "id", label: "Id" },
  { id: "customer", label: "Customer" },
  { id: "assignTo", label: "Assigned To" },
  { id: "quantity", label: "Item Count" },
  { id: "totalPrice", label: "Total Price" },
  { id: "paid", label: "Paid" },
  { id: "unpaid", label: "Balance" },
  { id: "createdAt", label: "Date" },
  { id: "status", label: "Status" },
  { id: "actions", label: "Actions", disableSorting: true },
];

const OrderPage = () => {
  const classes = useStyles();
  const history = useHistory();
  const { NotifyMessage, notify, setNotify } = Notify();
  const { viewAllOrdersWithPages, deleteMainOrder } = Order();
  const [recordForEdit] = useState(null);
  const [openPopup, setOpenPopup] = useState(false);
  const [openPopupAssign, setOpenPopupAssign] = useState(false);

  const [edit] = useState(false);
  const [id, setId] = useState(null);
  const [orders, setOrders] = useState([]);
  const [filteredOrders, setFilteredOrders] = useState([]);
  const [temp, setTemp] = useState([]);

  const [customers, setCustomers] = useState([]);
  const { viewAllCustomers } = Customer();
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [page, setPage] = useState(1);
  const [tot, setTot] = useState(1);
  const [limit, setLimit] = useState(15);
  const [totalPages, setTotalPages] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [actualTotal, setActualTotal] = useState();
  const [type, setType] = useState(null);
  const pageSizes = [15, 25, 50, 100];
  const [values, setValues] = useState({
    loading: false,
    reload: false,
  });
  const { loading, reload } = values;

  useEffect(() => {
    getAllOrders();
  }, [
    reload,
    page,
    limit,
    searchQuery,
    selectedCustomer,
    selectedStatus,
    type,
  ]);

  useEffect(() => {
    getAllCustomers();
  }, []);
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });

  const [additionalConfirmDialog, setAdditionalConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
    onConfirm: () => {},
  });

  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const getAllCustomers = () => {
    setValues({ ...values, loading: true });
    viewAllCustomers().then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else if (data.customers) {
        setValues({
          ...values,
          loading: false,
        });
        setCustomers(data.customers);
      }
    });
  };

  const getAllOrders = () => {
    setValues({ ...values, loading: true });
    viewAllOrdersWithPages(
      page,
      limit,
      searchQuery,
      selectedCustomer?.fullName,
      selectedStatus,
      null,
      null,
      null,
      type
    ).then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else if (data.orders) {
        setValues({
          ...values,
          loading: false,
        });
        const modifiedOrders = data.orders.map((order) => ({
          ...order,
          customer: order?.customer?.fullName,
          cusomerId: order?.customer?.id,
        }));
        setOrders(modifiedOrders);
        setFilteredOrders(modifiedOrders);
        setTemp(modifiedOrders);
        setCheckedItems("all");
        setTotalPages(Math.ceil(data.total / limit));
        setActualTotal(data.pagination.total);
        setTot(data.pagination.totalPages);
      }
    });
  };

  const onDelete = (Id) => {
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false,
    });
    setValues({ ...values, loading: true });

    deleteMainOrder(Id).then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
        setValues({ ...values, loading: false });
      } else {
        NotifyMessage({
          message: data.message,
          type: "success",
        });
        setValues({ ...values, loading: false });
        setOrders(
          produce(orders, (draft) => {
            const index = orders.findIndex((item) => item.id === Id);
            if (index !== -1) draft.splice(index, 1);
          })
        );
      }
    });
  };

  const {
    TblContainer,
    TblHead,
    TblPagination,
    recordsAfterSortingAndFiltering,
  } = useTable(orders, headCells, filterFn);

  const handleSearch = (e) => {
    setPage(1);
    setSearchQuery(e.target.value);
  };

  const calculateTotalPrice = (data) => {
    let totalPrice = 0;
    if (data.length > 0) {
      data.forEach((order) => {
        totalPrice += parseFloat(order.totalPrice);
      });
      return totalPrice.toFixed(2);
    }
  };

  const [checkedItems, setCheckedItems] = useState("all");

  const handleRadioChange = (event) => {
    const value = event.target.value;
    setPage(1);
    setType(value === "all" ? null : value);
  };

  const [orderConfirmDialog, setOrderConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const handleStatusChange = (e) => {
    const selectedStatus = e.target.value;
    setPage(1);
    setSelectedStatus(selectedStatus);
    setSearchQuery("");
  };
  const handleCustomerChange = (value) => {
    setPage(1);
    setSelectedCustomer(
      value ? { id: value.id, fullName: value.fullName } : null
    );
    setSearchQuery("");
  };
  const clearFilters = () => {
    setSelectedCustomer(null);
    setSelectedStatus(null);
    setPage(1);
    setLimit(15);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handlePageSizeChange = (event) => {
    setLimit(event.target.value);
    setPage(1);
  };
  const startIndex = (page - 1) * limit + 1;
  const endIndex = Math.min(startIndex + limit - 1, actualTotal);
  return (
    <Layout>
      <Admin>
        <div className="card">
          <Typography variant="h6" className="page-header">
            Orders
          </Typography>
          <Toolbar>
            <Controls.Input
              label="Search Orders"
              className="searchInput"
              fullWidth
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <AiOutlineSearch />
                  </InputAdornment>
                ),
              }}
              onChange={handleSearch}
            />
            <Controls.Button
              text="Add Order"
              variant="outlined"
              startIcon={<IoMdAdd />}
              className="newButton"
              onClick={() => {
                history.push(`/order`);
              }}
            />
          </Toolbar>

          <Box display="flex" justifyContent="start" gap={2} m={1}>
            <Autocomplete
              options={customers}
              sx={{ width: "17%" }}
              value={selectedCustomer}
              disableClearable
              getOptionLabel={(option) => `${option.fullName}`}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select Customer"
                  variant="outlined"
                  InputProps={{
                    ...params.InputProps,
                    type: "search",
                  }}
                />
              )}
              onChange={(event, value) => handleCustomerChange(value)}
            />
            <TextField
              id="outlined-select-status"
              select
              label="Filter By Status"
              sx={{ width: "15%" }}
              value={selectedStatus}
              onChange={handleStatusChange}
            >
              {statues().map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </TextField>
            {(selectedCustomer || selectedStatus) && (
              <Button
                variant="contained"
                onClick={clearFilters}
                endIcon={<ClearAllIcon />}
                sx={{
                  padding: "2px 6px", // Adjusted padding for a smaller size
                  fontSize: "0.75rem",
                  width: "100px",
                  marginTop: "14px",
                  height: "32px", // Decreased height
                  minHeight: "32px",
                  backgroundColor: "rgba(244,151,3,.8)",
                  color: "rgb(20,61,89)",
                  "&:hover": {
                    backgroundColor: "rgba(244,151,3,.8)",
                    color: "rgb(20,61,89)",
                  },
                }}
              >
                Clear
              </Button>
            )}
            <Box display="flex" justifyContent="flex-end" gap={1} m={1}>
              <FormGroup
                style={{
                  marginBottom: "20px",
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <FormControlLabel
                  control={
                    <Radio
                      checked={type === "myCreatedOrder"}
                      onChange={handleRadioChange}
                      value="myCreatedOrder"
                    />
                  }
                  label="My Created Order"
                />
                <FormControlLabel
                  control={
                    <Radio
                      checked={type === "myAssignedOrder"}
                      onChange={handleRadioChange}
                      value="myAssignedOrder"
                    />
                  }
                  label="My Assigned Order"
                />
                <FormControlLabel
                  control={
                    <Radio
                      checked={type === null}
                      onChange={handleRadioChange}
                      value="all"
                    />
                  }
                  label="All"
                />
              </FormGroup>
            </Box>
          </Box>
          <Grid container>
            <Grid item xs={12} className="card__body">
              {loading ? (
                <Loading />
              ) : (
                <Paper style={{ overflowX: "auto" }}>
                  <TblContainer>
                    <TblHead />
                    <TableBody>
                      {recordsAfterSortingAndFiltering().length > 0 ? (
                        recordsAfterSortingAndFiltering().map((item) => (
                          <TableRow key={item.id}>
                            <TableCell>
                              {item.orderId
                                ? item.orderId
                                : `${item.id.slice(0, 7)}--`}
                            </TableCell>
                            <TableCell>{item.customer}</TableCell>
                            <TableCell>{item.staff?.fullName}</TableCell>
                            <TableCell>{item?.orderProducts?.length}</TableCell>
                            <TableCell>
                              {item?.orderProducts?.length > 0
                                ? calculateTotalPrice(item.orderProducts)
                                : 0}
                            </TableCell>
                            <TableCell>{item.paid}</TableCell>
                            <TableCell>
                              {calculateTotalPrice(item.orderProducts) -
                                item.paid}
                            </TableCell>
                            <TableCell>
                              {new Date(item.createdAt).toLocaleString()}
                            </TableCell>
                            <TableCell>{item.status}</TableCell>
                            <TableCell>
                              <div
                                style={{
                                  display: "flex",
                                  gap: "5px",
                                  flexWrap: "nowrap",
                                }}
                              >
                                {item.status !== "Shipped" &&
                                  item.status !== "Ready for Shipment" && (
                                    <Controls.ActionButton
                                      color="secondary"
                                      title="Delete"
                                      onClick={() => {
                                        setConfirmDialog({
                                          isOpen: true,
                                          title:
                                            "Are you sure to delete this Order?",
                                          subTitle:
                                            "You can't undo this operation",
                                          onConfirm: () => {
                                            onDelete(item.id);
                                          },
                                        });
                                      }}
                                    >
                                      <MdOutlineDelete fontSize="medium" />
                                    </Controls.ActionButton>
                                  )}
                                {item.status !== "Shipped" &&
                                  item.status !== "Ready for Shipment" && (
                                    <Controls.ActionButton
                                      color="primary"
                                      title="Update"
                                      onClick={() => {
                                        history.push(`/orderDetail/${item.id}`);
                                      }}
                                    >
                                      <FiEdit fontSize="medium" />
                                    </Controls.ActionButton>
                                  )}
                                <Controls.ActionButton
                                  color="primary"
                                  title="View Detail"
                                  onClick={() => {
                                    history.push(`/print/${item.id}`);
                                  }}
                                >
                                  <FiEye fontSize="medium" />
                                </Controls.ActionButton>
                                <Controls.ActionButton
                                  color="primary"
                                  title="Assign"
                                  onClick={() => {
                                    setOpenPopupAssign(true);
                                    setId(item.id);
                                  }}
                                >
                                  <MdAssignmentInd fontSize="medium" />
                                </Controls.ActionButton>
                              </div>
                            </TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <Norecords col={6} />
                      )}
                    </TableBody>
                  </TblContainer>
                  <Box className={classes.paginationContainer}>
                    <Box display="flex" alignItems="center">
                      <Typography variant="body2" style={{ marginRight: 8 }}>
                        Rows per page:
                      </Typography>
                      <Select
                        value={limit}
                        onChange={handlePageSizeChange}
                        className={classes.pageSizeSelect}
                        size="small"
                      >
                        {pageSizes.map((size) => (
                          <MenuItem key={size} value={size}>
                            {size}
                          </MenuItem>
                        ))}
                      </Select>
                    </Box>
                    {actualTotal && (
                      <span>
                        {" "}
                        {startIndex}-{endIndex} of {actualTotal}
                      </span>
                    )}
                    {orders.length > 0 && (
                      <Pagination
                        count={totalPages}
                        page={page}
                        onChange={handlePageChange}
                        color="primary"
                        hideNextButton={page === tot || orders.length === 0}
                        hidePrevButton={page === 1}
                        shape="rounded"
                        siblingCount={1}
                        disabled={orders.length === 0}
                      />
                    )}
                  </Box>{" "}
                </Paper>
              )}
            </Grid>
          </Grid>
          <ConfirmDialog
            confirmDialog={confirmDialog}
            setConfirmDialog={setConfirmDialog}
          />
          <ConfirmDialog
            confirmDialog={additionalConfirmDialog}
            setConfirmDialog={setAdditionalConfirmDialog}
          />
          <OrderAssignConfirmDialog
            confirmDialog={orderConfirmDialog}
            setConfirmDialog={setOrderConfirmDialog}
          />
          <Notification notify={notify} setNotify={setNotify} />
        </div>
        <Popup
          title="Order Form"
          openPopup={openPopup}
          setOpenPopup={setOpenPopup}
        >
          <UpdateOrder
            NotifyMessage={NotifyMessage}
            setOpenPopup={setOpenPopup}
            recordForEdit={recordForEdit}
            setOrders={setOrders}
            getAllOrders={getAllOrders}
            edit={edit}
          />
        </Popup>
        <Popup
          title="Assign User"
          openPopup={openPopupAssign}
          setOpenPopup={setOpenPopupAssign}
        >
          <Assigntff
            NotifyMessage={NotifyMessage}
            setOpenPopup={setOpenPopupAssign}
            recordForEdit={recordForEdit}
            setOrders={setOrders}
            getAllOrders={getAllOrders}
            edit={edit}
            handleStatusChange={null}
            event={null}
            id={id}
          />
        </Popup>
      </Admin>
    </Layout>
  );
};

export default OrderPage;
